import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import Dropzone from "react-dropzone";
import classNames from "classnames";
var FileDropzone = function FileDropzone(_ref) {
  var onDropFiles = _ref.onDropFiles,
    isHidden = _ref.isHidden,
    isDropzoneDisabled = _ref.isDropzoneDisabled,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    acceptedFiles = _ref.acceptedFiles;
  if (isHidden) {
    return null;
  }
  var fileTypeAccepted = {
    accept: acceptedFiles ? acceptedFiles : ".jpeg, .jpg, .png, .dcm, image/jpeg, image/png, image/dcm, application/dicom"
  };
  return /*#__PURE__*/React.createElement(Dropzone, {
    onDrop: onDropFiles
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
      getInputProps = _ref2.getInputProps,
      open = _ref2.open;
    return /*#__PURE__*/React.createElement("section", {
      className: classNames(_defineProperty({}, className, !!className))
    }, /*#__PURE__*/React.createElement("div", getRootProps(_objectSpread({
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      className: classNames("h-full", {
        disabled: isDropzoneDisabled
      }),
      disabled: isDropzoneDisabled
    }, fileTypeAccepted)), !isDropzoneDisabled && /*#__PURE__*/React.createElement("input", getInputProps(_objectSpread({}, fileTypeAccepted))), children({
      open: open
    })));
  });
};
export default FileDropzone;